import {isEmpty, isNil} from 'ramda';

import {Nullish} from 'shared/web';

type GetCreationBranchChoiceInput = {
  activeBranchId: string | Nullish;
  vehicleBranchId: string | Nullish;
  accessibleBranchIds: string[];
};

type CreationBranchDialogChoice = {
  type: 'CHOOSE' | 'VEHICLE_BRANCH_INACCESSIBLE';
  activeBranchId: string;
  vehicleBranchId: string;
};

export type CreationBranchChoice = {type: 'NO_DIALOG'} | CreationBranchDialogChoice;

/**
 * Decides whether a record created from the vehicle card needs the user to confirm its branch.
 * The question is only real when the user can work in several branches and the vehicle belongs
 * to a branch other than the one selected in the header.
 */
export const getCreationBranchChoice = (
  input: GetCreationBranchChoiceInput
): CreationBranchChoice => {
  const {activeBranchId, vehicleBranchId, accessibleBranchIds} = input;

  if (
    isNil(activeBranchId) ||
    isNil(vehicleBranchId) ||
    isEmpty(vehicleBranchId) ||
    accessibleBranchIds.length <= 1 ||
    vehicleBranchId === activeBranchId ||
    // The selected branch is not resolved yet (empty or placeholder) — keep the default flow
    !accessibleBranchIds.includes(activeBranchId)
  ) {
    return {type: 'NO_DIALOG'};
  }

  return {
    type: accessibleBranchIds.includes(vehicleBranchId) ? 'CHOOSE' : 'VEHICLE_BRANCH_INACCESSIBLE',
    activeBranchId,
    vehicleBranchId,
  };
};
